<onboarding-container [hideBack]="true" [hideForward]="true">
  <p class="zero-text p-huge-med text-center">{{ 'onboarding.in-progress.headline' | transloco }}</p>
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-center align-items-md-stretch gap">
    <div class="d-flex flex-column align-items-center zero-surface grey-800 py-4 px-3 b-r-8 w-one-third">
      <web-design-system-icon name="pig" size="large" class="d-block mb-2" />
      <div class="zero-text p-bigger-med text-center mb-1">{{ 'onboarding.in-progress.card.pig.headline' | transloco }}</div>
      <div class="zero-text p-xsmall-reg label text-center">{{ 'onboarding.in-progress.card.pig.text' | transloco }}</div>
    </div>
    <div class="d-flex flex-column align-items-center zero-surface grey-800 py-4 px-3 b-r-8 w-one-third">
      <web-design-system-icon name="warren-buffet" size="large" class="d-block mb-2" />
      <div class="zero-text p-bigger-med text-center mb-1">{{ 'onboarding.in-progress.card.warren-buffet.headline' | transloco }}</div>
      <div class="zero-text p-xsmall-reg label text-center">{{ 'onboarding.in-progress.card.warren-buffet.text' | transloco }}</div>
    </div>
    <div class="d-flex flex-column align-items-center zero-surface grey-800 py-4 px-3 b-r-8 w-one-third">
      <web-design-system-icon name="arrow-box" size="large" class="d-block mb-2" />
      <div class="zero-text p-bigger-med text-center mb-1">{{ 'onboarding.in-progress.card.arrows.headline' | transloco }}</div>
      <div class="zero-text p-xsmall-reg label text-center">{{ 'onboarding.in-progress.card.arrows.text' | transloco }}</div>
    </div>
  </div>
  <div class="d-flex justify-content-center mt-4">
    <web-design-system-button [routerLink]="nextRoute">{{ 'onboarding.in-progress.btn' | transloco }}</web-design-system-button>
  </div>
  <a class="d-block zero-text link text-center mt-3" [routerLink]="maybeLaterTarget">{{ 'onboarding.in-progress.link' | transloco }}</a>
</onboarding-container>
